import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

import {
  ALLERGEN_LABEL_LEGEND_FRAGMENT,
  DIET_LABEL_LEGEND_FRAGMENT,
} from '../fragments'

const UPDATE_MENU_CURATION_TASK_STATUS_FLAG_MUTATION = gql`
  mutation updateMenuCurationTaskStatusFlagMutation(
    $id: ID!
    $data: MenuCurationTaskStatusFlagsUpdateInput!
  ) {
    updateMenuCurationTaskStatusFlag(id: $id, data: $data) {
      id
      taskStatus
      isUnknownWordsCurationDone
      isUnknownWordsQaDone
      isTierOneDone
      isCurationDone
      isQaDone
      isQcDone
      isReopenedManually
      updatedAt
      qadUnknownWordCount
      totalUnknownWordCount
      unknownWordsCuratedAt
      unknownWordsQadAt
      tierOneDoneAt
      curatedAt
      qadAt
      qcdAt
      latestTierOneDoneDishCount
      latestCuratedDishCount
      latestQadDishCount
      latestQcdDishCount
      latestCuratedUnknownWordCount
      latestQadUnknownWordCount
      isAvailableForTierOne
      isAvailableForUnknownWordsCuration
      isAvailableForUnknownWordsQa
      isAvailableForCuration
      isAvailableForQa
      isAvailableForQc
      tags

      dietLabelLegends {
        ...DietLabelLegendFragment
      }

      allergenLabelLegends {
        ...AllergenLabelLegendFragment
      }

      updatedBy {
        ...SimpleUserFragment
      }

      unknownWordsCuratedBy {
        ...SimpleUserFragment
      }

      unknownWordsQadBy {
        ...SimpleUserFragment
      }

      tierOneDoneBy {
        ...SimpleUserFragment
      }

      curatedBy {
        ...SimpleUserFragment
      }

      qadBy {
        ...SimpleUserFragment
      }

      qcdBy {
        ...SimpleUserFragment
      }

      assignedTierOneCurator {
        ...SimpleUserFragment
      }

      assignedCurator {
        ...SimpleUserFragment
      }

      assignedQa {
        ...SimpleUserFragment
      }

      assignedUnknownWordsCurator {
        ...SimpleUserFragment
      }

      assignedUnknownWordsQa {
        ...SimpleUserFragment
      }

      assignedQc {
        ...SimpleUserFragment
      }

      assignedScrapingReviewerUser {
        ...SimpleUserFragment
      }
    }
  }
  ${SIMPLE_USER_FRAGMENT}
  ${DIET_LABEL_LEGEND_FRAGMENT}
  ${ALLERGEN_LABEL_LEGEND_FRAGMENT}
`

export default UPDATE_MENU_CURATION_TASK_STATUS_FLAG_MUTATION
